export interface StatsTargetConfig {
  transformationRatePct: number;
  firstReplyHours: number;
  leadToSignedHours: number;
}

export const STATS_TARGETS: StatsTargetConfig = {
  transformationRatePct: 25,
  firstReplyHours: 2,
  leadToSignedHours: 24 * 7,
};
